// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"c3ad0a75d3c587411773","293":"338aa6948614bf5627aa"}[chunkId] + ".js";
};